import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import { AudioContext } from 'rewact'
import { ModalContext } from 'modaaals'
import { forceDownload } from '../../api'

import * as Icon from '../Icons'
import styles from './tracks.module.css'

function Tracks({
  tracks,
  requestType,
  requestId,
  playerTrack,
  setPlayerTrack,
}) {
  const { openModal } = useContext(ModalContext)
  const hasTracks = tracks && tracks.length > 0
  const [expanded, setExpanded] = useState(null)

  useEffect(() => {
    if (hasTracks) {
      setExpanded(tracks[0].slug)
    }
    return () => setExpanded(null)
  }, [hasTracks, tracks])

  return hasTracks ? (
    <>
      <h2 className={styles.tracksHeading}>
        <Icon.TracksList className={styles.tracksHeadingIcon} /> Tracks Results
      </h2>
      <div className={styles.tracks}>
        {tracks.map((track) => {
          const isCurrent =
            playerTrack.artist === track.artist &&
            playerTrack.name === track.name
          return (
            <TrackItem
              key={`${track.artist}_${track.name}`}
              isCurrent={isCurrent}
              setPlayerTrack={setPlayerTrack}
              requestType={requestType}
              requestId={requestId}
              openModal={openModal}
              setExpanded={setExpanded}
              expanded={expanded}
              {...track}
            />
          )
        })}
      </div>
    </>
  ) : null
}

function TrackItem({
  isCurrent,
  setPlayerTrack,
  requestType,
  requestId,
  openModal,
  setExpanded,
  expanded,
  ...track
}) {
  const { play, isPaused, pause } = useContext(AudioContext)
  const isPlayingCurrent = isCurrent && !isPaused
  const isExpanded = expanded === track.slug
  return (
    <div
      className={cn(styles.tracksPlayerItem, {
        [styles.expanded]: isExpanded,
        [styles.active]: isPlayingCurrent,
      })}
      onClick={() => {
        if (isExpanded) {
          setExpanded(null)
        } else {
          setExpanded(track.slug)
        }
      }}
    >
      <div className={styles.tracksPlayerImage}>
        {track.image ? (
          <img
            alt={`${track.name} by ${track.artist}`}
            src={`${process.env.REACT_APP_COVER_URI}/s/${track.image}`}
            className={styles.tracksPlayerImageImg}
          />
        ) : (
          <Icon.Placeholder style={{ color: '#ff3b57' }} />
        )}
        <div
          className={styles.tracksPlayerImagePlayBtn}
          onClick={(e) => {
            if (isExpanded) {
              e.preventDefault()
              e.stopPropagation()
              if (!isCurrent || (isCurrent && isPaused)) {
                setPlayerTrack(track)
                setTimeout(play, 300)
              } else {
                pause()
              }
            }
          }}
        >
          {isPlayingCurrent ? (
            <Icon.Pause />
          ) : (
            <Icon.Play style={{ marginLeft: 2 }} />
          )}
        </div>
      </div>
      <div className={styles.tracksPlayerInfo}>
        <p className={styles.tracksPlayerInfoName}>{track.name}</p>
        <p className={styles.tracksPlayerInfoArtist}>{track.artist}</p>
      </div>
      <div className={styles.tracksPlayerGenres}>
        {isExpanded ? (
          track.image ? (
            <img
              alt={`${track.name} by ${track.artist}`}
              src={`${process.env.REACT_APP_COVER_URI}/m/${track.image}`}
              className={styles.tracksPlayerBigImg}
            />
          ) : (
            <Icon.Placeholder
              style={{
                color: '#ff3b57',
                transform: 'scale(0.7)',
                transformOrigin: 'center right',
              }}
            />
          )
        ) : (
          track.genre?.map((genre) => (
            <span
              className={styles.tracksPlayerGenreButton}
              key={`${track.id}${genre}`}
            >
              {genre}
            </span>
          ))
        )}
      </div>
      <div className={styles.extras}>
        <button
          className={styles.downloadButton}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            forceDownload(
              `${process.env.REACT_APP_TRACK_URI}/${track.slug}.mp3`,
              `${track.artist}_${track.name}_preview.mp3`
            )
          }}
          title="Download Preview"
        >
          <Icon.Download />
          Preview
        </button>
        {track.price ? (
          track.purchased ? (
            track.purchasedId ? (
              <Link
                className={styles.buyButton}
                to={`/profile/purchased/${track.purchasedId}`}
              >
                View License
              </Link>
            ) : (
              <span className={styles.purchaseText} style={{ opacity: 1 }}>
                License already purchased
              </span>
            )
          ) : (
            <button
              className={styles.buyButton}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                openModal({
                  type: 'payment',
                  amount: track.price,
                  ...track,
                  trackId: track.id,
                  requestType,
                  requestId,
                })
              }}
            >
              <Icon.Cart className={styles.cartIcon} />
              Buy License ${track.price}
            </button>
          )
        ) : (
          <span className={styles.purchaseText}>
            We will quote your track as soon as possible.
          </span>
        )}
      </div>
    </div>
  )
}

export default Tracks
